// A process-wide serializer for demo verifications.
//
// runDemoVerification installs each receipt into a SHARED in-memory virtual
// filesystem, clearing it first, so two verifications that overlap in time
// would read each other's files. Both the recorded-layer effect (App.tsx) and
// the Overview hero cards (HeroPanel.tsx) funnel their runs through this single
// chain, so only one verification ever touches the virtual FS at a time — even
// across a mode switch, where a recorded run's React-effect cleanup suppresses
// its state update but cannot stop the async work already in flight.
let chain: Promise<unknown> = Promise.resolve();

export function runSerialized<T>(fn: () => Promise<T>): Promise<T> {
  // Run fn only after the previous run has settled (success or failure).
  const run = chain.then(fn, fn);
  // Keep the chain alive regardless of this run's outcome, and don't leak this
  // run's rejection into the shared chain — each caller handles its own errors.
  chain = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}
